import React, { useEffect, useRef, useCallback } from "react";
import lottie from "lottie-web";
import { Sonometer } from "sonometer/types/sonometer.model";
import { assetBaseUrl } from "./TextPopup";

interface AnimationPopupProps {
  sonometer?: Sonometer;
}

const AnimationPopup: React.FC<AnimationPopupProps> = ({ sonometer }) => {
  const animationContainer = useRef<HTMLDivElement>(null);

  // const hexToRGBA = (hex: string): [number, number, number, number] => {
  //   const bigint = parseInt(hex.slice(1), 16);
  //   const r = ((bigint >> 16) & 255) / 255;
  //   const g = ((bigint >> 8) & 255) / 255;
  //   const b = (bigint & 255) / 255;
  //   return [r, g, b, 1];
  // };

  const getAnimationPathByScore = useCallback((): string => {
    const score = sonometer?.score;

    if (!score) return "/misc/animations/anim_095-098_horn.json"; // Default animation

    if (score <= 92) {
      return "/misc/animations/anim_092_lawnmower.json";
    } else if (score > 92 && score <= 94) {
      return "/misc/animations/anim_092-094_subway.json";
    } else if (score > 94 && score <= 96) {
      return "/misc/animations/anim_094-096_horn.json";
    } else if (score > 96 && score <= 98) {
      return "/misc/animations/anim_096-098_airplane.json";
    } else if (score > 98 && score <= 100) {
      return "/misc/animations/anim_098-100_moto.json";
    } else if (score > 100 && score <= 102) {
      return "/misc/animations/anim_100-102_jackhammer.json";
    } else if (score > 102 && score <= 105) {
      return "/misc/animations/anim_102-105_siren.json";
    } else {
      return "/misc/animations/anim_105_formula1.json"; // score >= 105
    }
  }, [sonometer?.score]);

  const loadAndReplaceColors = useCallback(async () => {
    const animationPath = getAnimationPathByScore();
    const response = await fetch(animationPath);
    let animationData = await response.json();

    // Iterate through assets and update image paths if necessary
    if (animationData.assets) {
      animationData.assets.forEach((asset: any) => {
        if (asset.p === "psg.png") {
          asset.u = "/images/";
        }
      });
    }

    if (animationContainer.current) {
      // Clear any existing animation
      animationContainer.current.innerHTML = "";

      lottie.loadAnimation({
        container: animationContainer.current,
        renderer: "svg",
        loop: false,
        autoplay: true,
        animationData: animationData,
      });
    }
  }, [getAnimationPathByScore]);

  useEffect(() => {
    loadAndReplaceColors();
  }, [loadAndReplaceColors]);

  return (
    <div className="w-[1540px] h-[220px] overflow-hidden font-virage">
      <div className="flex h-full">
        {/* Left Sponsor - 260px */}
        <div className="w-[260px] h-[220px] flex items-center justify-center">
          <img
            src={
              sonometer?.publicScreenSettings.sponsorLogo ||
              assetBaseUrl + "/images/sponsor_left.png"
            }
            alt="Sponsor Qatar"
            className="max-w-full max-h-full object-contain block"
          />
        </div>

        {/* Margin - 200px
                <div className="w-[200px]"></div> */}

        {/* Animation Area - Flexible width */}
        <div className="flex-1 flex items-center justify-center">
          <div
            ref={animationContainer}
            className="w-full h-full transform  origin-left"
          />
        </div>

        {/* Right Section - 460px */}
        {/* <div className="w-[460px] h-[220px]"></div> */}
      </div>
    </div>
  );
};

export default AnimationPopup;
